import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiDatabase, FiSearch } from 'react-icons/fi';
import { JuliaMessageMetadata, JuliaStep } from '../../types';

interface JuliaActivityProps {
  active: boolean;
  metadata?: JuliaMessageMetadata | null;
}

const FALLBACK_STEPS: JuliaStep[] = [
  { phase: 'search', label: 'Analyse de votre demande…', status: 'running' },
  { phase: 'search', label: 'Exploration de l\'application…', status: 'pending' },
  { phase: 'found', label: 'Synthèse de la réponse…', status: 'pending' },
];

const JuliaActivity: React.FC<JuliaActivityProps> = ({ active, metadata }) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active) return undefined;
    const id = window.setInterval(() => setTick((t) => t + 1), 1200);
    return () => window.clearInterval(id);
  }, [active]);

  if (!active && !metadata?.steps?.length) return null;

  const steps = metadata?.steps?.length
    ? metadata.steps
    : FALLBACK_STEPS.map((s, i) => ({
        ...s,
        status: i <= tick % FALLBACK_STEPS.length ? (i < tick % FALLBACK_STEPS.length ? 'done' : 'running') : 'pending',
      }));

  return (
    <div
      style={{
        padding: '0.75rem 1rem',
        margin: '0.25rem 1rem',
        background: 'linear-gradient(135deg, #E0F2FE 0%, #ECFEFF 100%)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid rgba(14, 165, 233, 0.22)',
      }}
    >
      <p
        style={{
          margin: '0 0 0.5rem',
          fontSize: '0.65rem',
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: 'var(--color-brand)',
        }}
      >
        Julia travaille
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
        <AnimatePresence>
          {steps.slice(-5).map((step, index) => (
            <motion.div
              key={`${step.tool || step.label}-${index}`}
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: 'var(--font-size-xs)',
                color: step.status === 'done' ? 'var(--color-text-secondary)' : 'var(--color-text)',
              }}
            >
              {step.status === 'done' ? (
                <FiCheck size={14} style={{ color: 'var(--color-success)', flexShrink: 0 }} />
              ) : step.phase === 'search' ? (
                <FiSearch size={14} className="julia-spin" style={{ color: 'var(--color-brand)', flexShrink: 0 }} />
              ) : (
                <FiDatabase size={14} style={{ color: 'var(--color-brand)', flexShrink: 0 }} />
              )}
              <span>{step.label}</span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default JuliaActivity;
